import Vue from "vue";
import axios from "axios";
import { getToken, getLanguageCode, getVersionCode, getAppChannel, getPackageName, getOs } from "@mono/bridge";
// import { showTips } from "../../util/tip/index";
import { RES_COMMON_CODE } from "./constant";

const http = axios.create({
  timeout: 20000,
  baseURL: process.env.VUE_APP_SERVICE_URL,
  crossorigin: true,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
  transformRequest: [
    function (data) {
      return JSON.stringify(data);
    },
  ],
});

let languageCode = null;
let versionCode = null;
let packageName = null;
let channel = null;
let platform = null;

// 添加请求拦截器
export const requestInterceptor = http.interceptors.request.use(
  async (config) => {
    const token = await getToken();
    // console.log(`axios, interceptors, token:${token}`);
    config.headers["token"] = token;
    if (languageCode === null) {
      languageCode = await getLanguageCode();
    }
    config.headers["language_code"] = languageCode;
    if (versionCode === null) {
      versionCode = await getVersionCode();
    }
    config.headers["version_code"] = versionCode;
    if (packageName === null) {
      packageName = await getPackageName();
    }
    config.headers["package_name"] = packageName;
    if (channel === null) {
      channel = await getAppChannel();
    }
    config.headers["channel"] = channel;
    if (platform === null) {
      platform = await getOs();
    }
    config.headers["platform"] = platform;
    return config;
  }
);

http.interceptors.response.use(
  (response) => {
    if (response.status != 200) {
      // showTips(response.status, response.status);
    }
    return response.data;
  },
  (error) => {
    let code = RES_COMMON_CODE.C_NET_QEQUEST_ERROR;
    if (error.response) {
      code = error.response.status;
    }
    // showTips(error.message, code);
    return {
      code: code,
      messsage: error.message,
    };
  }
);
Vue.prototype.$http = http;

export default http;
